import { h } from '@stencil/core';

import { ButtonHeight, ButtonWidth } from '../ui-common/ico-button-animated/ico-button-animated';

export const DynamicEntryStartButton = ({
  label = 'Start My Offer',
  width = '2xs' as ButtonWidth,
  height = 'large' as ButtonHeight,
  whenClicked = () => {},
  isFetching = false,
  loaded = false,
  ...props
}) => (
  <ico-button-animated
    buttonState={loaded ? 'loaded' : isFetching ? 'loading' : 'normal'}
    color="start-action"
    {...{
      whenClicked,
      label,
      width,
      height,
      ...props,
    }}
  />
);
